<rid-demo-page [title]="'Fonologisch bewustzijn'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Wisselklanken" variant="PRIMARY" routerLink="klank-switch" [queryParams]="{ shuffle: 1 }" />
  <rid-button class="w-full" content="Woordpad" variant="PRIMARY" [disabled]="true" />
</rid-demo-page>
